import Query from 'library/util/query';
import DeepMerge from 'deepmerge';

const Q = (query, params = {}, {cancelToken, ...opts}={}) => {
  return Query(query, params, {
    ...DeepMerge(opts, {
      ajaxOptions: {
        baseURL: __INTERNALURL__
      }
    }),
    cancelToken: cancelToken
  });
};

export default Q;
